/**
 * nav.js
 * Javscript for the (mobile) site nav and header
 * Includes visual changes and a11y amends
 */


let gsap;

import { ANIM_CONFIG } from './anim-utils';
import { tms_destroy_focus_trap, tms_init_focus_trap} from './focus-trap';

;(function($, window, document, gsap) {

  const mobile_nav_breakpoint = 992;  // When the mobile nav gets shown
  let nav_focus_trap;


  // Open mobile nav when clicking/entering the toggle
  $('.toggle-nav').on('click', function (event: any) {

    const is_nav_open = $('body').hasClass('mobile-nav-open');

    if (is_nav_open) {
      nav_close();
      subnav_close();
    } else {
      nav_open();
      subnav_close();
    }

  });

  // Open sub nav on click or enter
  $('.menu-item-has-children .subnav-toggle').on('click', function (e) {
    e.preventDefault();

    const subnav = $(this).parent();
    const is_subnav_open = subnav.hasClass('subnav-open');

    if (is_subnav_open) {
      subnav_close();
    } else {
      subnav_open(subnav);
    }

  });



  
  // Keyboard Escape events on navs
  $('.site-header').on('keyup', '.subnav-open', ($event) => {
    $event.stopPropagation(); // Dont close the main nav, just the sub nav
    if ($event.key === "Escape") {
      subnav_close();
    }
  });

  $('.site-header').on('keyup', ($event) => {
    if ($event.key === "Escape") {
      subnav_close();
      nav_close();
    }
  });

  // Close menu whenever a link is clicked
  $('.menu-main-menu-container a').on('click', () => {
    nav_close();
  });


  // Click outside to close the subnav
  $('body').on('click', ($event) => {

    if ($event.target.closest('.subnav-toggle') || $event.target.closest('.subnav-menu') || $event.target.closest('.menu-main-menu-container a')) {
      return;
    }
    
    subnav_close();
  });


  // Nav and subnav open/close functions
  function nav_open() {
    $('body').addClass('mobile-nav-visible');
    $('.nav-menu').attr('aria-hidden', 'false'); // Set nav hidden on mobile

    requestAnimationFrame( () => {
      $('body').addClass('mobile-nav-open');
      $('html').addClass('noscroll');
      $('.toggle-nav').attr('aria-expanded', "true");

      nav_focus_trap = tms_init_focus_trap($('.site-header'));
      nav_aria_hidden(true);

      $('.toggle-nav').trigger('focus');

      $('.toggle-nav .screen-reader-text').text('Close Menu');
    });
  }

  function nav_close() {
    $('body').removeClass('mobile-nav-open');
    $('html').removeClass('noscroll');
    $('.toggle-nav').attr('aria-expanded', "false");
    $('.nav-menu').attr('aria-hidden', "true");
    $('.toggle-nav .screen-reader-text').text('Open Menu');
    
    tms_destroy_focus_trap(nav_focus_trap);
    nav_aria_hidden(false);

    setTimeout( () => { 
      $('body').removeClass('mobile-nav-visible');
    }, 100);

    $('.toggle-nav').trigger('focus');
  }


  // Nav and subnav open/close functions
  function subnav_open($subnav) {

    // Close other subnavs
    subnav_close();

    // $subnav.addClass('subnav-open');
    // // slideToggle($subnav.index(0));
    // $subnav.slideToggle()
    $subnav.find('.subnav-toggle').attr('aria-expanded', true);

    if ( window.innerWidth < mobile_nav_breakpoint) {

      /** 
       * Hide things to get them out of the focus trap / document selectables
       */

      // Hide the *other* header nav items
      // if ($subnav.hasClass('language-selector')) { // If site options
      //   $('.nav-menu').hide();
      //   $('.toggle-reduce-motion').hide();
      // } else {  // Main menu
        // $('.site-options').hide();
        $subnav.addClass('subnav-open');
        $subnav.find('.level-1').slideToggle(ANIM_CONFIG.duration);
      // }

      // tms_destroy_focus_trap(nav_focus_trap);
      // nav_focus_trap = tms_init_focus_trap($('.site-header'));
    } else {

      // Desktop - just show the subnav
      $subnav.addClass('subnav-open');

    }

  }

  function subnav_close() {

    const openSubnav = $('.subnav-open');
    openSubnav.find('.subnav-toggle').attr('aria-expanded', 'false');
    openSubnav.removeClass('subnav-open');
    
    if ( window.innerWidth < mobile_nav_breakpoint) {
      
      // // Show all things that were hidden
      // $('.site-header .logo').show();
      // $('.site-nav .menu-item').show(); // Siblings
      // // $('.site-options').show();
      // $('.nav-menu').show();
      // $('.toggle-reduce-motion').show();

      openSubnav.find('.level-1').slideUp(ANIM_CONFIG.duration);

      tms_destroy_focus_trap(nav_focus_trap);
      // nav_focus_trap = tms_init_focus_trap($('.site-header'));
    }
  }

  // Set aria hidden on various things    
  function nav_aria_hidden(is_hidden) {

    if ( window.innerWidth < mobile_nav_breakpoint) { // When the nav is the mobile version
      // Setting ARIA status
      $('.site-content, .site-footer, .skip-link').attr('aria-hidden', is_hidden);  // Global elements
    }
  }

  // Set initial nav state
  if (window.innerWidth <= mobile_nav_breakpoint) {
    $('.nav-menu').attr('aria-hidden', 'true'); // Set nav hidden on mobile
  }

  // Handle screen resize
  $(window).on('resize', function (){

    if (window.innerWidth <= mobile_nav_breakpoint) {
      $('.nav-menu').attr('aria-hidden', 'true'); // Set nav hidden on mobile
    } else {
      $('.nav-menu').attr('aria-hidden', 'false'); // Set nav hidden on mobile
    }

  })


  // @ts-ignore
})(jQuery, window, document, window.gsap);